import React from 'react';
import styled from 'styled-components';
import { Link, Text, UpliftIcons } from 'up-ops-web-shared-components/lib';
import theme from 'up-ops-web-shared-components/lib/styles/theme';

const StyledContainer = styled.div`
  svg {
    height: 1.3rem;
    width: auto;
    vertical-align: middle;
  }

  svg + a {
    margin-left: 0.5rem;
  }

  & + & {
    margin-top: 1rem;
  }
`;

const StyledHint = styled(Text)`
  margin-left: 0.5rem;
`;

type FileDownloadLinkProps = {
  hint?: string;
  href: string;
  text: string;
};

const FileDownloadLink = ({ hint = '', href, text }: FileDownloadLinkProps) => {
  return (
    <StyledContainer>
      <UpliftIcons.Document size="1.3rem" />
      <Link newTab href={href}>
        {text}
      </Link>
      {hint && <StyledHint color={theme.colors.textLight}>{hint}</StyledHint>}
    </StyledContainer>
  );
};

export default FileDownloadLink;
